<template>
  <div class="tabbar-container">
    <div class="tabbar">
      <div
        v-if="!isLoggedIn"
        class="tabbar-item"
        :class="{ active: activePage === 'home' }"
        @click="goToPage('/home')"
      >
        <div class="icon-container">
          <img :src="getIconPath('home')" alt="首页" />
        </div>
        <div class="text">首页</div>
      </div>

      <div
        class="tabbar-item"
        :class="{ active: activePage === 'teacher' }"
        @click="goToPage('/strategylist')"
      >
        <div class="icon-container">
          <img :src="getIconPath('teacher')" alt="老师" />
        </div>
        <div class="text">老师</div>
      </div>

      <div
        class="tabbar-item"
        :class="{ active: activePage === 'question' }"
        @click="goToPage('/jsyl')"
      >
        <div class="icon-container">
          <img :src="getIconPath('question')" alt="问答" />
        </div>
        <div class="text">问答</div>
      </div>

      <div
        class="tabbar-item"
        :class="{ active: activePage === 'user' }"
        @click="goToPage('/user')"
      >
        <div class="icon-container">
          <img :src="getIconPath('user')" alt="我的" />
        </div>
        <div class="text">我的</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheTabbar",
  props: {
    activePage: {
      type: String,
      default: "home",
      validator: (value) => {
        return ["home", "teacher", "question", "user"].includes(value);
      },
    },
  },
  data() {
    return {
      iconPaths: {
        home: {
          active: require("@/assets/tabbar-icons/home-a.png"),
          normal: require("@/assets/tabbar-icons/home.png"),
        },
        teacher: {
          active: require("@/assets/tabbar-icons/teacher-a.png"),
          normal: require("@/assets/tabbar-icons/teacher.png"),
        },
        question: {
          active: require("@/assets/tabbar-icons/faq-a.png"),
          normal: require("@/assets/tabbar-icons/faq.png"),
        },
        user: {
          active: require("@/assets/tabbar-icons/personal-a.png"),
          normal: require("@/assets/tabbar-icons/personal.png"),
        },
      },
    };
  },
  computed: {
    isLoggedIn() {
      return localStorage.getItem("login_status") === "true";
    },
  },
  methods: {
    goToPage(path) {
      try {
        if (this.$route && this.$route.path !== path && this.$router) {
          this.$router.push({ path });
        }
      } catch (error) {
        console.log("路由跳转异常:", error);
      }
    },
    getIconPath(iconName) {
      return this.activePage === iconName
        ? this.iconPaths[iconName].active
        : this.iconPaths[iconName].normal;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabbar-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background-color: #fff;
  border-top: 1px solid #f2f2f2;
  padding-bottom: env(safe-area-inset-bottom);
}

.tabbar {
  display: flex;
  height: 50px;
  padding: 5px 0;
  justify-content: space-around;
}

.tabbar-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  max-width: 25%; /* Ensure items don't get too wide even when one is hidden */

  &.active {
    .text {
      color: #000;
    }
  }
}

.icon-container {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  margin-bottom: 2px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.text {
  font-size: 12px;
  color: #999;
  line-height: 1.2;
}
</style>
